import { IConfigurationModel, IProductModel, IScreenModel } from "@nf/common";

import { SEO } from "../../components";
import { LandingPageHeader } from "components/LandingPage";
import LandingPageSection from "components/LandingPage/LandingPageSection";

import { mergeComponents } from "./utils";

export interface LandingScreenProps {
  configuration?: IConfigurationModel;
  screen: IScreenModel;
  offers?: IProductModel[];
}

const LandingScreen = ({
  configuration,
  screen,
  offers,
}: LandingScreenProps) => {
  const components = screen?.Components;

  if (!components?.length) {
    return null;
  }

  const sections = mergeComponents(components);

  return (
    <>
      <SEO screenKey="landingpage" configuration={configuration} />

      {configuration?.System?.CustomScript && (
        <div
          dangerouslySetInnerHTML={{
            __html: configuration.System.CustomScript,
          }}
        />
      )}

      <LandingPageHeader />

      {sections.map((section) => (
        <LandingPageSection
          key={section.Id}
          component={section}
          offers={offers}
        />
      ))}
    </>
  );
};

export default LandingScreen;
